import React, { useState } from "react";
import { ProjectTypeList } from "./ProjectTypeList";
import {
  ABOUT_PROJECT_STEPS,
  PROJECT_TYPES,
} from "../../../constant/common.constant";
import { UserOnboardingInfo } from "../../../types";
import { TeamName } from "./TeamName";
import { ProjectSize } from "./ProjectSize";
import { ContactPhone } from "./ContactPhone";

interface Props {
  onNextStep: (values: UserOnboardingInfo) => void;
  setOnboardingInfo: React.Dispatch<React.SetStateAction<UserOnboardingInfo>>;
  onboardingInfo: UserOnboardingInfo;
  onPreviousStep: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  isAuthorizedDistributor: boolean;
  hasInviteToken: boolean;
}

export const AboutProject = ({
  onNextStep,
  onPreviousStep,
  onboardingInfo,
  setOnboardingInfo,
  isAuthorizedDistributor,
  hasInviteToken,
}: Props) => {
  const [currentStep, setCurrentStep] = useState(
    ABOUT_PROJECT_STEPS.PROJECT_TYPE
  );

  const onBack = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    switch (currentStep) {
      case ABOUT_PROJECT_STEPS.PROJECT_TYPE:
        onPreviousStep(e);
        break;
      case ABOUT_PROJECT_STEPS.CONTACT_PHONE:
        setCurrentStep(ABOUT_PROJECT_STEPS.PROJECT_TYPE);
        break;
      case ABOUT_PROJECT_STEPS.TEAM_NAME:
        setCurrentStep(
          onboardingInfo.forWho === PROJECT_TYPES.DISTRIBUTOR
            ? ABOUT_PROJECT_STEPS.CONTACT_PHONE
            : ABOUT_PROJECT_STEPS.PROJECT_TYPE
        );
        break;
      case ABOUT_PROJECT_STEPS.PROJECT_SIZE:
        setCurrentStep(ABOUT_PROJECT_STEPS.TEAM_NAME);
        break;

      default:
        break;
    }
  };

  return (
    <>
      {currentStep === ABOUT_PROJECT_STEPS.PROJECT_TYPE && (
        <ProjectTypeList
          onPreviousStep={onBack}
          setOnboardingInfo={setOnboardingInfo}
          onboardingInfo={onboardingInfo}
          onNextStep={(formValues) => {
            //If the user was invited, we don't ask for the project and team info (since the user is joining a team...)
            //A default Team and project will still be created though...
            if (hasInviteToken) {
              onNextStep(formValues);
            } else {
              setCurrentStep(
                formValues.forWho === PROJECT_TYPES.DISTRIBUTOR
                  ? ABOUT_PROJECT_STEPS.CONTACT_PHONE
                  : ABOUT_PROJECT_STEPS.TEAM_NAME
              );
            }
          }}
          isAuthorizedDistributor={isAuthorizedDistributor}
        />
      )}
      {currentStep === ABOUT_PROJECT_STEPS.CONTACT_PHONE && (
        <ContactPhone
          onPreviousStep={onBack}
          setOnboardingInfo={setOnboardingInfo}
          onboardingInfo={onboardingInfo}
          onNextStep={() => setCurrentStep(ABOUT_PROJECT_STEPS.TEAM_NAME)}
        />
      )}
      {currentStep === ABOUT_PROJECT_STEPS.TEAM_NAME && (
        <TeamName
          onPreviousStep={onBack}
          setOnboardingInfo={setOnboardingInfo}
          onboardingInfo={onboardingInfo}
          onNextStep={() => setCurrentStep(ABOUT_PROJECT_STEPS.PROJECT_SIZE)}
        />
      )}
      {currentStep === ABOUT_PROJECT_STEPS.PROJECT_SIZE && (
        <ProjectSize
          onPreviousStep={onBack}
          setOnboardingInfo={setOnboardingInfo}
          onboardingInfo={onboardingInfo}
          onNextStep={onNextStep}
        />
      )}
    </>
  );
};
